import { createFileRoute, redirect } from "@tanstack/react-router";

// The contact page moved to its SEO slug /kontakt-mi-support. Permanently
// redirect the old /kontakt path so existing links and bookmarks keep working.
export const Route = createFileRoute("/kontakt")({
  beforeLoad: () => {
    throw redirect({ to: "/kontakt-mi-support", statusCode: 301 });
  },
});
